import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'varadiMetal/progressMap';

const progressMapService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default progressMapService;
